module.exports = __webpack_public_path__ + "static/banner-mobile-2c673c49ffd86b6e54174c3d59bf6b29.png";